import type { TooltipOptions } from 'primevue/tooltip';

export const GEN_IDV_STYLED_TOOLTIP = (text: string = '', { allowWhitespace = false } = {}) =>
    ({
        value: allowWhitespace ? text : text.trim().replace(/\s/g, ' '),
        fitContent: true,
        pt: {
            root: { class: 'max-w-sm w-fit' },
            text: { class: 'bg-ds-primary-900 text-ds-primary-50' },
        },
    }) as TooltipOptions;
